export const types = {
    UPDATE_TIMELINE: 'UPDATE_TIMELINE',
};

// Initial State
const state = {
    open: true,
};

// Getters
const getters = {
    isTimelineOpen: state => state.open,
};

// Actions
const actions = {
    updateTimeline: ({ commit }) => commit(types.UPDATE_TIMELINE),
};


// Mutations
const mutations = {
    [types.UPDATE_TIMELINE](state) {
        state.open = !state.open;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/timeline.js